export default __webpack_public_path__ + "static/media/cover.c0febdc7.jpg";